import { defineMessages } from 'react-intl';

/**
 * The copy of the old Assets tab (designs m2, m2b, m5, m6, e3). The web Assets tab of Releases v2
 * uses `revisionCardMessages.ts`; the native apps still render most of these ids (native parity
 * follow-up), and the make hooks read the toasts.
 */
export const assetMessages = defineMessages({
  // ---- groups (m2) ----
  groupStreaming: { id: 'app.sml.releases.assets.group.streaming', defaultMessage: 'For streaming services' },
  groupStreamingHint: {
    id: 'app.sml.releases.assets.group.streamingHint',
    defaultMessage: 'Upload in the artist portals',
  },
  groupYoutube: { id: 'app.sml.releases.assets.group.youtube', defaultMessage: 'For YouTube' },
  groupYoutubeHint: { id: 'app.sml.releases.assets.group.youtubeHint', defaultMessage: 'Full song and Shorts' },
  groupSocials: { id: 'app.sml.releases.assets.group.socials', defaultMessage: 'For socials' },
  groupSocialsHint: {
    id: 'app.sml.releases.assets.group.socialsHint',
    defaultMessage: 'Instagram, TikTok, Facebook, Threads',
  },
  groupImages: { id: 'app.sml.releases.assets.group.images', defaultMessage: 'Images' },
  groupImagesHint: { id: 'app.sml.releases.assets.group.imagesHint', defaultMessage: 'Profiles and links' },

  // ---- card titles and uses (m2) ----
  canvasTitle: { id: 'app.sml.releases.assets.canvas.title', defaultMessage: 'Canvas loop' },
  canvasUse: {
    id: 'app.sml.releases.assets.canvas.use',
    defaultMessage: 'The looping video behind the song in the Spotify player.',
  },
  coverTitle: { id: 'app.sml.releases.assets.cover.title', defaultMessage: 'Cover sizes' },
  coverUse: {
    id: 'app.sml.releases.assets.cover.use',
    defaultMessage: 'The artwork at the size each store and the distributor asks for.',
  },
  motionTitle: { id: 'app.sml.releases.assets.motion.title', defaultMessage: 'Motion artwork' },
  motionUse: {
    id: 'app.sml.releases.assets.motion.use',
    defaultMessage: 'Animated album art. Your distributor delivers it.',
  },
  thumbnailTitle: { id: 'app.sml.releases.assets.thumbnail.title', defaultMessage: 'Thumbnail' },
  thumbnailUse: { id: 'app.sml.releases.assets.thumbnail.use', defaultMessage: 'For your YouTube upload of the song.' },
  visualizerTitle: { id: 'app.sml.releases.assets.visualizer.title', defaultMessage: 'Visualizer' },
  visualizerUse: {
    id: 'app.sml.releases.assets.visualizer.use',
    defaultMessage: 'The artwork moves with the song. Your "official audio".',
  },
  lyricVideoTitle: { id: 'app.sml.releases.assets.lyricVideo.title', defaultMessage: 'Lyric video' },
  lyricVideoUse: {
    id: 'app.sml.releases.assets.lyricVideo.use',
    defaultMessage: 'Every line on screen as it is sung.',
  },
  musicVideoTitle: { id: 'app.sml.releases.assets.musicVideo.title', defaultMessage: 'Music video' },
  musicVideoUse: {
    id: 'app.sml.releases.assets.musicVideo.use',
    defaultMessage: 'AI footage cut on the beat of the whole song.',
  },
  lyricMomentTitle: { id: 'app.sml.releases.assets.lyricMoment.title', defaultMessage: 'Lyric moment' },
  lyricMomentUse: {
    id: 'app.sml.releases.assets.lyricMoment.use',
    defaultMessage: 'The lines you pick, each word at its sung time.',
  },
  presaveStoryTitle: { id: 'app.sml.releases.assets.presaveStory.title', defaultMessage: 'Pre-save story' },
  presaveStoryUse: {
    id: 'app.sml.releases.assets.presaveStory.use',
    defaultMessage: 'Points fans to the pre-save page.',
  },
  countdownSetTitle: { id: 'app.sml.releases.assets.countdownSet.title', defaultMessage: 'Countdown set' },
  countdownSetUse: {
    id: 'app.sml.releases.assets.countdownSet.use',
    defaultMessage: 'One story for each day before the release.',
  },
  outNowStoryTitle: { id: 'app.sml.releases.assets.outNowStory.title', defaultMessage: 'Out now story' },
  outNowStoryUse: {
    id: 'app.sml.releases.assets.outNowStory.use',
    defaultMessage: 'Tells fans the song is out, with a link to listen.',
  },
  lyricStoryTitle: { id: 'app.sml.releases.assets.lyricStory.title', defaultMessage: 'Lyric story' },
  lyricStoryUse: { id: 'app.sml.releases.assets.lyricStory.use', defaultMessage: 'One line of the song as a story.' },
  announcePostTitle: { id: 'app.sml.releases.assets.announcePost.title', defaultMessage: 'Announce post' },
  announcePostUse: {
    id: 'app.sml.releases.assets.announcePost.use',
    defaultMessage: 'Tells your feed that the song comes out soon.',
  },
  feedPostTitle: { id: 'app.sml.releases.assets.feedPost.title', defaultMessage: 'Out now post' },
  feedPostUse: { id: 'app.sml.releases.assets.feedPost.use', defaultMessage: 'The release-day post for the feed.' },
  lyricCardTitle: { id: 'app.sml.releases.assets.lyricCard.title', defaultMessage: 'Lyric card' },
  lyricCardUse: {
    id: 'app.sml.releases.assets.lyricCard.use',
    defaultMessage: 'One line of the song on a square card.',
  },
  countdownVideoTitle: { id: 'app.sml.releases.assets.countdownVideo.title', defaultMessage: 'Countdown videos' },
  countdownVideoUse: {
    id: 'app.sml.releases.assets.countdownVideo.use',
    defaultMessage: 'Three short videos: 7, 3 and 1 days to go.',
  },
  artworkMotionTitle: { id: 'app.sml.releases.assets.artworkMotion.title', defaultMessage: 'Artwork in motion' },
  artworkMotionUse: {
    id: 'app.sml.releases.assets.artworkMotion.use',
    defaultMessage: 'The cover moves with the best part of the song.',
  },
  bannersTitle: { id: 'app.sml.releases.assets.banners.title', defaultMessage: 'Banners' },
  bannersUse: {
    id: 'app.sml.releases.assets.banners.use',
    defaultMessage: 'Profile headers that announce the release.',
  },
  spotifyHeaderTitle: { id: 'app.sml.releases.assets.spotifyHeader.title', defaultMessage: 'Spotify header' },
  spotifyHeaderUse: {
    id: 'app.sml.releases.assets.spotifyHeader.use',
    defaultMessage: 'The top of your Spotify artist page.',
  },
  linkPreviewTitle: { id: 'app.sml.releases.assets.linkPreview.title', defaultMessage: 'Link preview' },
  linkPreviewUse: {
    id: 'app.sml.releases.assets.linkPreview.use',
    defaultMessage: 'The image a chat app shows when a fan shares the smartlink.',
  },
  // ---- AI reels card (m2) ----
  reelsTitle: { id: 'app.sml.releases.assets.reels.title', defaultMessage: 'AI reels' },
  reelsReady: { id: 'app.sml.releases.assets.reels.ready', defaultMessage: '{count} ready' },
  reelsSpec: { id: 'app.sml.releases.assets.reels.spec', defaultMessage: 'Beat-synced · lyric captions' },
  reelsUse: { id: 'app.sml.releases.assets.reels.use', defaultMessage: 'Each reel has its own review.' },
  reelsOpen: { id: 'app.sml.releases.assets.reels.open', defaultMessage: 'Open the reels' },
  makeReel: { id: 'app.sml.releases.assets.reels.make', defaultMessage: 'Make an AI reel' },

  // ---- spec lines ----
  specFull: { id: 'app.sml.releases.assets.spec.full', defaultMessage: 'Full song' },
  specApple: { id: 'app.sml.releases.assets.spec.apple', defaultMessage: 'For Apple Music' },
  specSize: { id: 'app.sml.releases.assets.spec.size', defaultMessage: '{width} × {height}' },
  specVersion: { id: 'app.sml.releases.assets.spec.version', defaultMessage: 'Version {version} · {date}' },
  specWatermark: { id: 'app.sml.releases.assets.spec.watermark', defaultMessage: 'Free plan · with watermark' },
  specQueued: { id: 'app.sml.releases.assets.spec.queued', defaultMessage: 'Waits for the asset before it' },
  specFreeLock: { id: 'app.sml.releases.assets.spec.freeLock', defaultMessage: 'Free plan · short videos only' },

  // ---- status pill (m2b) ----
  statusMissing: { id: 'app.sml.releases.assets.status.missing', defaultMessage: 'Not made' },
  statusQueued: { id: 'app.sml.releases.assets.status.queued', defaultMessage: 'Queued' },
  statusMaking: { id: 'app.sml.releases.assets.status.making', defaultMessage: 'Making {progress}%' },
  statusReady: { id: 'app.sml.releases.assets.status.ready', defaultMessage: 'Ready' },
  statusFailed: { id: 'app.sml.releases.assets.status.failed', defaultMessage: 'Failed' },
  // The native apps still read these two ids (scripts/music24-native/i18n-keys.txt). Keep them until they stop.
  lockArtist: { id: 'app.sml.releases.assets.status.lockArtist', defaultMessage: 'Pro' },
  lockUse: {
    id: 'app.sml.releases.assets.lock.use',
    defaultMessage: 'Upgrade to Pro for full-song videos and full quality.',
  },

  // ---- card actions ----
  newVersion: { id: 'app.sml.releases.assets.action.newVersion', defaultMessage: 'New version' },
  makeIt: { id: 'app.sml.releases.assets.action.makeIt', defaultMessage: 'Make it' },
  tryAgain: { id: 'app.sml.releases.assets.action.tryAgain', defaultMessage: 'Try again' },
  openCatalog: { id: 'app.sml.releases.assets.action.openCatalog', defaultMessage: 'Open the catalog' },
  // ---- toolbar (m2) ----
  readyCount: { id: 'app.sml.releases.assets.toolbar.ready', defaultMessage: '{ready} of {total} ready' },
  downloadAll: { id: 'app.sml.releases.assets.toolbar.downloadAll', defaultMessage: 'Download all (.zip)' },
  makeSomething: { id: 'app.sml.releases.assets.toolbar.makeSomething', defaultMessage: 'Make something' },
  makeMissing: {
    id: 'app.sml.releases.assets.toolbar.makeMissing',
    defaultMessage: 'Make the {count} missing',
  },
  zipEmailing: { id: 'app.sml.releases.assets.toast.zipEmailing', defaultMessage: 'We email you the link.' },
  zipFailed: { id: 'app.sml.releases.assets.toast.zipFailed', defaultMessage: 'The zip could not be made. Try again.' },
  busy: { id: 'app.sml.releases.assets.toast.busy', defaultMessage: 'This is already being made.' },
  // "Make the kit" with too few video credits (owner rule 2026-10-06).
  imagesOnly: {
    id: 'app.sml.releases.assets.toast.imagesOnly',
    defaultMessage:
      'MUSIC24 is making the images now. The videos need {credits, plural, one {# credit} other {# credits}}.',
  },
  skippedTitle: {
    id: 'app.sml.releases.assets.skipped.title',
    defaultMessage:
      '{count, plural, one {# video waits for credits} other {# videos wait for credits}}. They need {credits, plural, one {# credit} other {# credits}}.',
  },
  skippedBuy: { id: 'app.sml.releases.assets.skipped.buy', defaultMessage: 'Buy credits to make the videos' },
  skippedMake: {
    id: 'app.sml.releases.assets.skipped.make',
    defaultMessage: '{count, plural, one {Make the video} other {Make the # videos}}',
  },
  makeFailed: {
    id: 'app.sml.releases.assets.toast.makeFailed',
    defaultMessage: 'MUSIC24 could not start this. Try again.',
  },
  noMaster: {
    id: 'app.sml.releases.assets.toast.noMaster',
    defaultMessage: 'Add the master of the song first. Videos read the song.',
  },
  skippedNoMaster: {
    id: 'app.sml.releases.assets.toast.skippedNoMaster',
    defaultMessage: 'We are making the images. The videos need the master of the song: add it, then make them.',
  },
  skippedMasterProcessing: {
    id: 'app.sml.releases.assets.toast.skippedMasterProcessing',
    defaultMessage: 'We are making the images. The master is still processing: make the videos in a minute.',
  },

  // ---- kit in progress (m5, e1) ----
  progressTitle: { id: 'app.sml.releases.assets.progress.title', defaultMessage: 'Making the {title} kit' },
  progressCount: { id: 'app.sml.releases.assets.progress.count', defaultMessage: '{ready} of {total}' },
  progressRead: { id: 'app.sml.releases.assets.progress.read', defaultMessage: 'Read the song and the artwork' },
  progressReadHint: {
    id: 'app.sml.releases.assets.progress.readHint',
    defaultMessage: 'The tempo, the hook and 5 colours from the cover',
  },
  progressImages: {
    id: 'app.sml.releases.assets.progress.images',
    defaultMessage: '{count, plural, one {Made # image} other {Made # images}}',
  },
  progressImagesWorking: {
    id: 'app.sml.releases.assets.progress.imagesWorking',
    defaultMessage: '{count, plural, one {Making # image} other {Making # images}}',
  },
  progressImagesHint: {
    id: 'app.sml.releases.assets.progress.imagesHint',
    defaultMessage: 'Cover sizes, stories, banners, thumbnail, link preview',
  },
  progressVideos: {
    id: 'app.sml.releases.assets.progress.videos',
    defaultMessage: '{count, plural, one {Making the video} other {Making # videos}}',
  },
  progressVideosDone: {
    id: 'app.sml.releases.assets.progress.videosDone',
    defaultMessage: '{count, plural, one {Made the video} other {Made # videos}}',
  },
  progressVideosHint: {
    id: 'app.sml.releases.assets.progress.videosHint',
    defaultMessage:
      '{count, plural, one {# video credit} other {# video credits}}. Videos of one workspace render one at a time.',
  },
  progressDeliver: { id: 'app.sml.releases.assets.progress.deliver', defaultMessage: 'Check and deliver' },
});
